// extracted by mini-css-extract-plugin
export default {"doubleScroll":"top-scrollbar_doubleScroll__s2U26","topScroll":"top-scrollbar_topScroll__jXNoJ","scrollDisabled":"top-scrollbar_scrollDisabled__cG4dk"};